/**
 * Weekly Menu - Minimal JavaScript
 * Responsibilities:
 * - Mark active variant pill
 * - Update price textContent from radio data-price
 * - Update portionsvægt text from radio data-portionsvaegt
 * - Quantity +/- logic (min 1)
 * 
 * No DOM mutation, no MutationObserver, no price HTML rewriting
 */

(function() {
  'use strict';

  function initWeeklyMenu() {
    const section = document.querySelector('.weekly-menu-section');
    if (!section) return;

    const cards = section.querySelectorAll('.weekly-menu-card');
    
    cards.forEach(card => {
      initCard(card);
    });
  }

  function initCard(card) {
    const form = card.querySelector('[data-weekly-menu-form]');
    if (!form) return;

    const variantRadios = form.querySelectorAll('.weekly-menu-variant-radio');
    const priceElement = form.querySelector('[data-price]');
    const portionElement = form.querySelector('[data-portionsvaegt-display]');
    const productId = card.getAttribute('data-product-id');
    const qtyInput = form.querySelector('[data-quantity-input]');
    const minusBtn = form.querySelector('[data-quantity-minus]');
    const plusBtn = form.querySelector('[data-quantity-plus]');

    // Only run variant logic if multiple variants exist
    if (variantRadios.length > 1) {
      // Initialize active state and text from checked radio
      syncVariantUI(variantRadios, priceElement, portionElement, productId);

      // Listen for variant changes
      variantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          syncVariantUI(variantRadios, priceElement, portionElement, productId);
        });
      });
    }
    // For single-variant cards, price and portion are already correct from Liquid

    // Quantity controls
    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', () => {
        const currentQty = parseInt(qtyInput.value) || 1;
        const newQty = Math.max(1, currentQty - 1);
        qtyInput.value = newQty;
      });

      plusBtn.addEventListener('click', () => {
        const currentQty = parseInt(qtyInput.value) || 1;
        qtyInput.value = currentQty + 1;
      });

      // Ensure min value on input change
      qtyInput.addEventListener('change', () => {
        const currentQty = parseInt(qtyInput.value) || 1;
        if (currentQty < 1) {
          qtyInput.value = 1;
        }
      });
    }
  }

  function syncVariantUI(radios, priceElement, portionElement, productId) {
    const checkedRadio = Array.from(radios).find(r => r.checked);
    if (!checkedRadio) return;

    // Update pill active states
    radios.forEach(radio => {
      const label = radio.nextElementSibling;
      if (label && label.hasAttribute('data-variant-label')) {
        if (radio.checked) {
          label.classList.add('is-active');
        } else {
          label.classList.remove('is-active');
        }
      }
    });

    // Update price text (textContent only, no HTML injection)
    if (priceElement) {
      const priceText = checkedRadio.getAttribute('data-price');
      if (priceText) {
        priceElement.textContent = priceText;
      }
    }

    // Update portionsvægt text on card
    const portionGrams = checkedRadio.getAttribute('data-portionsvaegt');
    if (portionElement && portionGrams) {
      portionElement.textContent = portionGrams;
    }

    // Sync with nutrition modal if open for this product
    if (productId && portionGrams && window.Alpine) {
      try {
        const nutritionStore = window.Alpine.store('nutrition');
        if (nutritionStore && nutritionStore.isOpenFor(productId)) {
          // Update modal's portion weight display
          nutritionStore.modalData.portionGrams = portionGrams;
        }
      } catch (e) {
        // Silently fail if Alpine not available (e.g., during page load)
        console.debug('Alpine nutrition store not available:', e);
      }
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWeeklyMenu);
  } else {
    initWeeklyMenu();
  }

  // Re-initialize on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.weekly-menu-section')) {
      initWeeklyMenu();
    }
  });

})();
